import React, { Suspense, useMemo } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useAuth } from './contexts/authContext';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const RestrictPage = React.lazy(() => import('./pages/RestrictPage'));
const PublicPages = React.lazy(() => import('./pages/PublicPages'));

const App = () => {
  const { isAccessToken } = useAuth();

  const Renderer = useMemo(() => {
    return (
      <Suspense fallback={loading}>
        {isAccessToken ? (
          <BrowserRouter>
            <Suspense fallback={loading}>
              <Routes>
                <Route path="*" element={<RestrictPage />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        ) : (
          <PublicPages />
        )}
      </Suspense>
    );
  }, [isAccessToken]);

  return <div data-testid="app-page">{Renderer}</div>;
};

export default App;
